import { Alert, Button } from "@mui/material";
import { useGetPendingRoleIntentsQuery } from "Api/Queries/Roles/useGetPendingRoleIntentsQuery";
import { useNavigate } from "Navigation/useNavigate";
import { AccessRoleCodes } from "Models/AccessRoleCodes";
import { Resources, useResource } from "Translations/Resources";
import { appUrl } from "Utils/UrlUtils";

const COMPONENT_RESOURCES = Resources.Roles.AddRole.Banner;

/**
 * "Finish your registration as…" — a pending role intent. Two sources share this banner: an
 * invitation from an affiliate deep-link (carries an affiliate code) and the role the person chose
 * on the sign-up form (no code — self-selected, so the copy must not call it an invitation).
 * The intent lives server-side (survives devices) and retires once the role completes.
 */
export const PendingRoleIntentsBanner = () => {
  const { t } = useResource();
  const navigate = useNavigate();
  const { data } = useGetPendingRoleIntentsQuery();

  const intent = data?.items[0];

  if (!intent) {
    return null;
  }

  const isInvitation = !!intent.affiliateCode;
  const isMerchant = intent.accessRoleCode === AccessRoleCodes.Merchant;

  const message = isInvitation
    ? t(isMerchant ? COMPONENT_RESOURCES.Merchant : COMPONENT_RESOURCES.Hunter)
    : t(
        isMerchant
          ? COMPONENT_RESOURCES.SignUpIntent.Merchant
          : COMPONENT_RESOURCES.SignUpIntent.Hunter,
      );

  return (
    <Alert
      severity="info"
      action={
        <Button
          color="inherit"
          size="small"
          onClick={() =>
            navigate(appUrl("add-role"), {
              state: { preselectedRole: intent.accessRoleCode },
            })
          }
        >
          {t(COMPONENT_RESOURCES.Button)}
        </Button>
      }
    >
      {message}
    </Alert>
  );
};
